<script setup>
import { postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { reactive, ref, unref } from "vue";

const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);

let formModel = ref({});
const formRef = ref();

const rules = reactive({
  name: [
    {
      required: true,
      message: "请输入任务名称",
      trigger: "blur",
    },
  ],
  cron: [
    {
      required: true,
      message: "请输入cron",
      trigger: "blur",
    },
  ],
  jobClassName: [
    {
      required: true,
      message: "请输入job类名",
      trigger: "blur",
    },
  ],
});

const handleAdd = () => {
  handleEdit({});
};

const handleEdit = (record) => {
  formModel.value = Object.assign({}, { ...record });
  open.value = true;
};

const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();
};

const handleConfirm = async () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = unref(formModel);
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    request("/quartz", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};

defineExpose({
  handleAdd,
  handleEdit,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="任务名称" name="name">
        <a-input v-model:value="formModel.name" placeholder="请输入任务名称" />
      </a-form-item>
      <a-form-item label="job类名" name="jobClassName">
        <a-input
          v-model:value="formModel.jobClassName"
          placeholder="请输入job类名"
        />
      </a-form-item>
      <a-form-item label="cron" name="cron">
        <a-input v-model:value="formModel.cron" placeholder="请输入cron" />
      </a-form-item>
      <a-form-item label="参数" name="parameter">
        <a-input v-model:value="formModel.parameter" placeholder="请输入参数" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style scoped lang="scss"></style>
